import {
  createMultiStyleConfigHelpers,
  MultiStyleType,
  StyleThemingProps,
} from '~/utils/chakraUtils'
import { mergeMultiStyleConfig } from '~/utils/styleHelpers'

import { textStyleKeys } from '@mangovoice/design-system'
import { textStyles } from '@mangovoice/design-system'

const ContactCardsListParts = [
  'emptySearchResultsBody',
  'emptySearchResultsIcon',
  'emptySearchResultsStatusText',
  'emptySearchResultsText',
  'searchResultsContainer',
  'searchResultsProgress',
  'searchResultsList',
  'emptySearchBody',
  'emptySearchIcon',
  'emptySearchTextContainer',
  'emptySearchText',
  'resultsHeader',
  'resultsHeaderText',
  'resultsHeaderSubText',
  'recentsList',
] as const

const helpers = createMultiStyleConfigHelpers(ContactCardsListParts)
export const ContactCardsList = helpers.defineMultiStyleConfig({
  baseStyle: {
    emptySearchResultsBody: {
      flexDirection: 'column',
      alignItems: 'center',
      height: 'full',
      width: 'full',
      paddingTop: '2.5rem',
      gap: '0.5rem',
    },
    emptySearchResultsIcon: {
      boxSize: '5.625rem',
      color: 'fg.muted',
    },
    emptySearchResultsStatusText: {
      color: 'fg.muted',
      ...textStyles[textStyleKeys.Body1_Bold],
    },
    emptySearchResultsText: {
      color: 'fg.muted',
      ...textStyles[textStyleKeys.Body2],
    },
    searchResultsContainer: {
      justifyContent: 'center',
      alignItems: 'center',
      height: '2rem',
      paddingTop: '5rem',
    },
    searchResultsProgress: {
      color: 'border.muted',
      trackColor: 'fg.muted',
      size: '2rem',
    },
    searchResultsList: {
      display: 'flex',
      width: 'full',
      height: 'full',
    },
    emptySearchBody: {
      width: 'full',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      paddingY: '2.5rem',
      paddingX: '3rem',
      gap: '1.25rem',
    },
    emptySearchIcon: {
      boxSize: '5.625rem',
      color: 'fg.muted',
    },
    emptySearchTextContainer: {
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      height: '5.0625rem',
      width: 'full',
    },
    emptySearchText: {
      color: 'fg.muted',
      ...textStyles[textStyleKeys.H6],
      textAlign: 'center',
    },
    resultsHeader: {
      flexDirection: 'column',
      width: 'full',
      paddingTop: '1.75rem',
      paddingX: '0.75rem',
      paddingBottom: '1rem',
      gap: '0.75rem',
      borderBottom: '1px solid',
      borderColor: 'border.muted',
    },
    resultsHeaderText: {
      ...textStyles[textStyleKeys.Body2_Bold],
    },
    resultsHeaderSubText: {
      ...textStyles[textStyleKeys.Body1],
      color: 'fg.muted',
    },
    recentsList: {
      display: 'flex',
      widht: 'full',
      height: 'full',
    },
  },
})

export const useContactCardsListStyles = (props?: StyleThemingProps) => {
  return mergeMultiStyleConfig(ContactCardsList, props) as MultiStyleType<
    typeof ContactCardsListParts
  >
}
